import React from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUser, AiOutlineStar } from "react-icons/ai";

const Course = ({ image, category, title, participants, rating, price }) => {
  const { t } = useTranslation();
  return (
    <div className="p-2 shadow-lg w-full h-full flex flex-col bg-white rounded-md">
      <img
        src={image}
        className="max-w-full h-auto object-cover"
        alt={t(title)}
      />
      <div className="mt-2 text-xs text-Teal">{t(category)}</div>
      <div className="text-sm mt-2 font-bold flex-1">{t(title)}</div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="bg-Solitude p-1 rounded-full">
            <AiOutlineUser className="text-Teal" />
          </div>
          <div className="text-sm font-bold">{participants}</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="bg-Solitude p-1 rounded-full">
            <AiOutlineStar className="text-yellow" />
          </div>
          <div className="text-sm font-bold">{rating}</div>
        </div>
        {/* <div className="text-sm font-bold">${price}</div> */}
      </div>
    </div>
  );
};

export default Course;
